import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

if ($('#mapboxWrapperCard').length) {
  const marker = $('#mapbox-marker-card');

  if (marker.attr('data-lng')) {
    var markerPosition = new mapboxgl.LngLat(
      marker.attr('data-lng'),
      marker.attr('data-lat')
    );

    mapboxgl.accessToken =
      'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsYWIxOWNyOTAxdHozdm54a2RkMDc0c2cifQ.VCQxy0JOqWzuhET_TUQd-A';

    var map = new mapboxgl.Map({
      container: 'mapboxWrapperCard',
      style: 'mapbox://styles/blackdesk/clab1a00i000n14lvpm12njaa',
      attributionControl: false,
      center: markerPosition,
      maxZoom: 18,
      minZoom: 6,
      zoom: 15,
    });

    var el = document.createElement('div');
    el.className = 'marker-custom';
    el.style.backgroundImage =
      'url(/wp-content/themes/kappelle/public/images/marker.svg)';

    new mapboxgl.Marker(el).setLngLat(markerPosition).addTo(map);
  }
}

$(function () {
  if (map) {
    map.scrollZoom.disable();
    map.on('load', function () {
      map.resize();
    });
  }
});
